module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact_form--group"
  }, [(_vm.finished === false) ? _c('vue-form', {
    staticClass: "contact_form",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('validate', {
    staticClass: "field",
    class: _vm.fieldClassName(_vm.formstate.name),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.name),
      expression: "model.name"
    }],
    staticClass: "input",
    attrs: {
      "id": "name",
      "type": "text",
      "name": "name",
      "placeholder": "Hello! My name is",
      "required": ""
    },
    domProps: {
      "value": (_vm.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "auto-label": "",
      "name": "name",
      "show": "$touched || $submitted"
    }
  }, [_c('div', [_vm._v("Nice to meet you, " + _vm._s(_vm.model.name))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Let me know how to address you.")])])], 1), _vm._v(" "), _c('validate', {
    staticClass: "field",
    class: _vm.fieldClassName(_vm.formstate._replyto),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model._replyto),
      expression: "model._replyto"
    }],
    staticClass: "input",
    attrs: {
      "id": "email",
      "type": "email",
      "placeholder": "Email",
      "name": "_replyto",
      "required": ""
    },
    domProps: {
      "value": (_vm.model._replyto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "_replyto", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "auto-label": "",
      "name": "_replyto",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Email is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "email"
    },
    slot: "email"
  }, [_vm._v("Email is not valid")])])], 1), _vm._v(" "), _c('validate', {
    staticClass: "field",
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "message"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.message),
      expression: "model.message"
    }],
    staticClass: "textarea",
    attrs: {
      "id": "message",
      "name": "message",
      "placeholder": "What can I do for you?"
    },
    domProps: {
      "value": (_vm.model.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "message", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text",
      "name": "_gotcha"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-large is-outlined is-primary"
  }, [_vm._v("Say Hello")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.finished === true) ? _c('div', {
    staticClass: "contact_form-finished"
  }, [_c('h3', [_vm._v("Thank you for your mail.")]), _vm._v(" "), _c('p', [_vm._v("You should hear back within 24 hours. While you wait, here's a great clip to demonstrate the famous Edison Quote, “I have not failed. I've just found 10,000 ways that won't work.”")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Let's work together and discover the 10,001"), _c('sup', [_vm._v("st")]), _vm._v(" way that works. I'm looking forward to it.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-container"
  }, [_c('iframe', {
    attrs: {
      "width": "853px",
      "height": "480px",
      "src": "https://www.youtube.com/embed/Awf45u6zrP0",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a3d4550"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact/Contact.vue
// module id = 79
// module chunks = 0